import React from 'react';
import FullCard from '../../../../components/Card/FullCard';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { useHistory } from 'react-router-dom';
import useRules from '../../../../hooks/useRules';
import useTitle from 'hooks/useTitle';

const Paramenters = (props) => {
  useTitle('مدیریت پارامتر ها');
  const history = useHistory();
  const allChilds = props.config.childs;
  const [rules, hasRule, isAdmin] = useRules();

  return (
    <FullCard title={props.config.name}>
      <List>
        {allChilds
          .filter((r) => hasRule(r.slug))
          .map((r, i) => {
            return (
              <ListItem key={i} button>
                <ListItemText
                  onClick={() => history.push(`/protected/admin${r.path}`)}
                >
                  {r.name}
                </ListItemText>
              </ListItem>
            );
          })}
      </List>
    </FullCard>
  );
};

export default Paramenters;
